<template>
	<div>
		<ul class="uk-pagination" uk-margin v-if="items.last_page > 1">
			<li v-if="items.current_page > 1">
				<a :href="items.prev_page_url"><span uk-pagination-previous></span></a>
			</li>

			<li v-for="page of items.last_page" :class="items.current_page == page ? 'uk-active' : ''">
				<a :href="'/?page=' + page"><span>{{ page }}</span></a>
			</li>

			<li v-if="items.last_page > items.current_page">
				<a :href="items.next_page_url"><span uk-pagination-next></span></a>
			</li>

		</ul>
	</div>
</template>

<script>
  export default {
    name: "pagin",
    data() {
      return {
      }
    },
    props: {
      items: ''
    },
    methods: {}
  }
</script>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/pagination.vue